import { createApiRef } from '@backstage/core-plugin-api';

export const secDashApiRef = createApiRef<SecDashApi>({
  id: 'plugin.secdash.service',
});

type Props = {
  parameters: {
    project: string | undefined;
    scanner: string | undefined;
    severity: string | undefined;
    timeframe: string | undefined;
    app: string | undefined;
  };
};

export interface SecDashApi {
  get(path: string): Promise<any>;
  getData({
    parameters: { project, scanner, severity, timeframe, app },
  }: Props): Promise<any>;
  getScannerExplanations(scanner: string | undefined): Promise<any>;
  getAccordionProjects(group: string): Promise<any>;
}
